import React from 'react';
import { Text, Button } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { trackEvent } from '../../../helpers/analytics';
import { openChat } from '../../../helpers/supportChat';

const ContactUs = ({ title, companyId }) => (
  <Text fontSize="12px" marginTop="8px">
    If the {title} has changed,{' '}
    <Button
      type="button"
      variant="link"
      fontSize="12px"
      fontWeight="400"
      color="text.main"
      sx={{
        textDecoration: 'underline',
      }}
      p="0"
      onClick={() => {
        openChat();
        trackEvent(`employers:report_${title?.split(' ').join('_').toLowerCase()}_click`, {
          companyId,
        });
      }}
    >
      contact us
    </Button>
    .
  </Text>
);

ContactUs.propTypes = {
  title: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default ContactUs;
